// extracted by mini-css-extract-plugin
export default {"container":"Wrapper_container--XEN","header":"Wrapper_header--NV9","body":"Wrapper_body--OVY"};